import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import CityMap from './pages/CityMap';
import DetailedLocationView from './pages/DetailedLocationView';
import AdminPanel from './components/AdminPanel';
import AuthPage from './pages/AuthPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import VerifyStudentEmailPage from './pages/VerifyStudentEmailPage';
import VerificationPage from './pages/VerificationPage';
import GuidePage from './pages/GuidePage'; // Import the new GuidePage
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import { AuthProvider } from './context/AuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
    const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "593938798414-72ril6oj086ig5n5ju7utamn9h46hrn3.apps.googleusercontent.com";

    return (
        <GoogleOAuthProvider clientId={googleClientId}>
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/city/:cityName" element={<CityMap />} />
                    <Route path="/location/:cityName/:locationId" element={<DetailedLocationView />} />
                    <Route path="/admin" element={<ProtectedAdminRoute />}>
                        <Route index element={<AdminPanel />} />
                    </Route>
                    <Route path="/auth" element={<AuthPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/verify-academic-email" element={<VerifyStudentEmailPage />} />
                    <Route path="/verify" element={<ProtectedRoute><VerificationPage /></ProtectedRoute>} />
                    <Route path="/guide/:guidePath" element={<GuidePage />} /> {/* Add the new guide route */}
                </Routes>
            </AuthProvider>
        </GoogleOAuthProvider>
    );
}

export default App;